const PowerBIReport = () => {
    return (
        <div className="my-5">
            <iframe
                title="Eviction Trends Analysis"
                src="https://app.powerbi.com/view?r=eyJrIjoiOTQwMzgwNzYtMjlmYy00YTE5LWI3MjQtZDc0ZjA5MDY3YTVjIiwidCI6IjNmODZkMWI0LTJjNmItNGIxYS1iMmFlLTZmNWU5NTBiY2ExZSIsImMiOjh9"
                className="w-full h-[500px] rounded-lg shadow-md"
                frameBorder="0"
                allowFullScreen
            />
        </div>
    );
}

export default PowerBIReport;